[
    {
        "name": "first_run",
        "label": "First Run",
        "description": "Indicates if the application is running the first time",
        "type": "Boolean",
        "value": "true",
        "enabled": true
    },
    {
        "name": "authentication",
        "label": "Authentication",
        "description": "Enable application authentication",
        "type": "Boolean",
        "value": "false",
        "enabled": true
    },
    {
        "name": "auto_remove_old_checks",
        "label": "Auto remove old checks",
        "description": "Automatically delete checks older than the configured number of days once per day",
        "type": "AutoOldChecks",
        "value": {
            "days": 365,
            "lastRunAt": null
        },
        "enabled": false
    },
    {
        "name": "auto_remove_old_logs",
        "label": "Auto remove old logs",
        "description": "Automatically delete logs older than the configured number of days once per day",
        "type": "AutoOldLogs",
        "value": {
            "days": 120,
            "lastRunAt": null
        },
        "enabled": true
    },
    {
        "name": "share_enabled",
        "label": "Enable Sharing",
        "description": "Allow users to share checks via public links",
        "type": "Boolean",
        "value": "true",
        "enabled": true
    },
    {
        "name": "sso_enabled",
        "label": "Enable SSO",
        "description": "Enable Single Sign-On (SSO) authentication",
        "type": "Boolean",
        "value": "false",
        "enabled": true
    },
    {
        "name": "sso_protocol",
        "label": "SSO Protocol",
        "description": "Protocol used for SSO (oauth2 or saml)",
        "type": "String",
        "value": "oauth2",
        "enabled": true
    },
    {
        "name": "sso_entry_point",
        "label": "SSO Entry Point",
        "description": "URL of the Identity Provider (IdP) entry point",
        "type": "String",
        "value": "",
        "enabled": true
    },
    {
        "name": "sso_issuer",
        "label": "SSO Issuer",
        "description": "Entity ID of the Identity Provider",
        "type": "String",
        "value": "",
        "enabled": true
    },
    {
        "name": "sso_client_id",
        "label": "SSO Client ID",
        "description": "Client ID for OAuth2",
        "type": "String",
        "value": "",
        "enabled": true
    }
]